import { c as _c } from "react/compiler-runtime";
import { FormSelect } from '@systemeio/ui';
import { WrapperChildrenPropsInterface } from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import { TriggerEmailItemProps } from 'modules/automation-rules/triggers/components/edit-triggers/components/trigger-email-item/index';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { AutomationRuleBaseDataInterface } from 'modules/automation-rules/types/automation-rule-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import { MailingId } from 'modules/mailing/types/mailing-interface';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface EmailSelectProps extends Omit<TriggerEmailItemProps, 'onDelete' | 'triggers' | 'setRules' | 'idx' | 'trigger'>, Pick<WrapperChildrenPropsInterface, 'onOpen'> {
  onChange: (data?: number) => void;
  mailingId?: MailingId;
  triggerId: number;
  subject?: string;
  emailData?: AutomationRuleBaseDataInterface[];
}
const EmailSelect = t0 => {
  const $ = _c(21);
  const {
    errors,
    onOpen,
    onChange,
    mailingId,
    subject,
    triggerId,
    emailData
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== onOpen) {
    t1 = () => onOpen(AutomationRuleTriggersDataEnum.email);
    $[0] = onOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("global.email");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("dashboard.automation_rule.choose_email");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== mailingId || $[7] !== subject) {
    t4 = getDataFromObj({
      id: mailingId,
      name: subject
    });
    $[6] = mailingId;
    $[7] = subject;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== errors.automationTriggers || $[10] !== triggerId) {
    t5 = errors.automationTriggers[triggerId]?.mailing?.join("");
    $[9] = errors.automationTriggers;
    $[10] = triggerId;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== emailData || $[13] !== mailingId || $[14] !== onChange || $[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
    t6 = <FormSelect onOpen={t1} label={t2} required={true} placeholder={t3} value={mailingId} staticData={t4} data={emailData} onChange={onChange} error={t5} />;
    $[12] = emailData;
    $[13] = mailingId;
    $[14] = onChange;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
export default EmailSelect;